import React from 'react'

const Container = ({ children }) => {
  return (
    <div className='flex min-h-screen w-full overflow-x-hidden bg-gray-100'>{children}</div>
  )
}

export default Container
